<template>
  <div class="kt-portlet kt-portlet--height-fluid">
    <div class="kt-portlet__body">
      <div class="kt-widget4">
        <div v-if="linkIsSuccess">
          <h4>
            Your item is now linked to Mixcloud
          </h4>

          <br><br>

          <iframe width="100%"
                  frameBorder="0"
                  seamless
                  :src="`${player_url}/embed/item/${itemUuid}?layout=legacy`">
            Browser not compatible!
          </iframe>

          <iframe width="100%"
                  frameBorder="0"
                  seamless
                  :src="`https://api.mixcloud.com${mixcloudKey}embed-html`">
            Browser not compatible!
          </iframe>
        </div>

        <h4 v-else>
          Could not link your item to Mixcloud
        </h4>

        You can close this window.
      </div>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    linkIsSuccess: {
      type: Boolean,
      required: true,
      default: false,
    },

    mixcloudKey: {
      type: String,
      default: null,
    },

    itemUuid: {
      type: String,
      default: null,
    },

  },

  data() {
    return {
      player_url: window.timbre_player_url,

    };
  },

};
</script>
